import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  withRouter,
  Link,
} from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';

import {
  Typography,
  CircularProgress,
  Toolbar,
  Button,
} from '@material-ui/core';

import DashboardLayout from '../../dashboard/components/DashboardLayout';
import Alert from '../../common/components/Alert';
import ActivityList from '../components/ActivityList';
import * as activitiesActions from '../actions';
import classes from '../../css/getCSS';
import * as routes from '../../config/routes';


class Activities extends Component {
  componentDidMount() {
    const type = this.props.match.params.type;  // eslint-disable-line
    document.title = this.getDocTitle(type);
    this.props.getActivities(
      this.props.token,
      type,
    );
    window.scrollTo(0, 0);
  }

  componentWillReceiveProps(nextProps) {
    const type = nextProps.match.params.type;  // eslint-disable-line
    if (this.props.match.params.type !== type) {
      this.props.onUnmount();
      this.props.getActivities(
        this.props.token,
        type,
      );
      document.title = this.getDocTitle(type);
      window.scrollTo(0, 0);
    }
  }

  componentWillUnmount() {
    this.props.onUnmount();
  }

  getDocTitle = (type) => {
    let title = null;
    if (type === 'shortlists') {
      title = 'Manage Shortlists';
    }
    if (type === 'interests' || type === 'sent-interests') {
      title = 'Manage Interests';
    }
    if (type === 'requests' || type === 'sent-requests') {
      title = 'Manage Requests';
    }
    if (type === 'recommendations') {
      title = 'Manage Recommendations';
    }
    if (type === 'messages') {
      title = 'Messages';
    }
    return title;
  }

  loadMore = (url) => {
    this.props.getActivities(
      this.props.token,
      this.props.match.params.type,
      url,
    );
  }

  render() {
    let loading = null;

    if (this.props.loading) {
      loading = (
        <div align="center" style={{ marginTop: '50px' }}>
          <CircularProgress align="center" size={50} /> <br />
          <Typography variant="body1">Loading. Please wait</Typography>
        </div>
      );
    }

    let errorAlert = null;
    if (this.props.error) {
      errorAlert = <Alert type="danger">{this.props.error}</Alert>;
    }

    let list = null;

    if (this.props.count > 0) {
      list = (
        <ActivityList
          list={this.props.activityList}
          count={this.props.count}
          next={this.props.next}
          type={this.props.match.params.type}
          loadMore={this.loadMore}
        />
      );
    } else if (!this.props.loading) {
      list = (
        <div className={classes.padding20} align="center">
          <Typography variant="headline">No data found!</Typography>
        </div>
      );
    }

    let title = null;
    let dashActiveLink = null;
    const type = this.props.match.params.type;  // eslint-disable-line
    if (type === 'shortlists') {
      title = 'Shortlists';
      dashActiveLink = 'shortlists';
    }
    if (type === 'interests') {
      title = 'Received Interests';
      dashActiveLink = 'interests';
    }
    if (type === 'sent-interests') {
      title = 'Sent Interests';
      dashActiveLink = 'interests';
    }
    if (type === 'requests') {
      title = 'Received Requests';
      dashActiveLink = 'requests';
    }
    if (type === 'sent-requests') {
      title = 'Sent Requests';
      dashActiveLink = 'requests';
    }
    if (type === 'messages') {
      title = 'Messages';
      dashActiveLink = 'messages';
    }
    if (type === 'recommendations') {
      title = 'Recommendations';
      dashActiveLink = 'recommendations';
    }

    let activityNav = null;
    if (type === 'interests' || type === 'requests' || type === 'sent-interests' || type === 'sent-requests') {
      let recLink = formatRoute(routes.ACTIVITIES, { type: type });  // eslint-disable-line
      let sentLink = formatRoute(routes.ACTIVITIES, { type: type });  // eslint-disable-line
      if (type === 'sent-interests') { recLink = formatRoute(routes.ACTIVITIES, { type: 'interests' }); }
      if (type === 'sent-requests') { recLink = formatRoute(routes.ACTIVITIES, { type: 'requests' }); }
      if (type === 'interests') { sentLink = formatRoute(routes.ACTIVITIES, { type: 'sent-interests' }); }
      if (type === 'requests') { sentLink = formatRoute(routes.ACTIVITIES, { type: 'sent-requests' }); }
      activityNav = (
        <Toolbar>
          <Link className={classes.linkDeCSS} to={recLink}>
            <Button variant={!type.startsWith('sent') ? 'outlined' : 'flat'}>Received</Button>
          </Link>
          <Link className={classes.linkDeCSS} to={sentLink}>
            <Button variant={type.startsWith('sent') ? 'outlined' : 'flat'}>Sent</Button>
          </Link>
        </Toolbar>
      );
    }

    return (
      <DashboardLayout
        isAuthenticated
        activeLink="home"
        dashActiveLink={dashActiveLink}
        user={this.props.user}
      >
        {activityNav}
        <div className={classes.padding10XS}>
          <Typography variant="headline">{title}</Typography>
        </div>
        <br />
        {list}
        {loading}
        {errorAlert}
      </DashboardLayout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    user: state.auth.user,
    loading: state.activities.loading,
    error: state.activities.error,
    activityList: state.activities.activityList,
    count: state.activities.count,
    next: state.activities.next,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUnmount: () => dispatch(activitiesActions.onUnmount()),
    getActivities: (token, type, url) => dispatch(
      activitiesActions.getActivities(token, type, url),
    ),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Activities));



// WEBPACK FOOTER //
// ./src/activities/containers/Activities.js